<template>
    <div>
        <h5 class="mb-2">{{ $t('talk.modal.templates') }}</h5>
        <multiselect-color
            :options="options"
            :state="state"
            :placeholder="$t('talk.templates') + '...'"
            :loading="loading"
            :hideLabel="true"
            :multiple="false"
            :clearOnSelect="false"
            :closeOnSelect="true"
            :searchable="true"
            :hideSelected="false"
            @changeValue="setSelectedTemplate"
        />
    </div>
</template>

<script>
import { MultiselectColor } from '@/views/components/selects'
import { getTemplates } from './api'

export default {
    name: 'TemplatesSelect',
    components: {
        MultiselectColor,
    },
    data() {
        return {
            options: [],
            state: null,
            loading: false,
            selected: null,
        }
    },
    mounted() {
        this.getTemplatesFromApi()
    },
    methods: {
        getTemplatesFromApi() {
            this.loading = true

            getTemplates()
                .then(templates => {
                    this.setTemplates(templates)
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        setTemplates(templates) {
            this.options = this.mapToColorOptions(templates)
        },
        mapToColorOptions(options) {
            return options.map(e => {
                return {
                    color: {
                        hex: '#022B4F',
                    },
                    label: e.title,
                    value: e.id,
                    askings: e.askings,
                }
            })
        },
        setSelectedTemplate(template) {
            if (!template) {
                this.selected = null
                return
            }

            this.selected = {
                id: template.value,
                title: template.label,
                asks: template.askings,
            }
        },
    },
    watch: {
        selected() {
            this.$emit('template-selected', this.selected)
        },
    },
}
</script>
